import React from 'react';
import { navigate, setLinkProps } from 'hookrouter';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const LinkButton = (props) => (
  <Form.Group controlId="formSubmit">
    <Button
      variant="occu-primary"
      {...setLinkProps(props)}
      onClick={(event) => {
        event.preventDefault();
        navigate(props.href);
      }}
      block
    >
      {props.children}
    </Button>
  </Form.Group>
);

export { LinkButton };
